export const PRIVACY_POLICY_THRESHOLD: number = 30;
